import type { InputFilterMenu as InputFilterMenuType } from '@/components/FilterMenu'
import { useTranslation } from 'react-i18next'

interface HiveIdFilterProps {
  selectedValue: string | null
  onSearch: (value: string) => void
  InputFilterMenu: typeof InputFilterMenuType
}

export function HiveIdFilter({
  selectedValue,
  onSearch,
  InputFilterMenu,
}: HiveIdFilterProps) {
  const { t } = useTranslation()

  return (
    <InputFilterMenu
      buttonLabel={t('clusterConfigTable.filters.hiveId')}
      headerTitle={
        t('components.inputFilterMenu.filterBy', {
          label: t('clusterConfigTable.filters.hiveId'),
        }) as string
      }
      placeholder={
        t('components.inputFilterMenu.typePlaceholder', {
          label: t('clusterConfigTable.filters.hiveId'),
        }) as string
      }
      hint={
        t('components.inputFilterMenu.enterHint', {
          label: t('clusterConfigTable.filters.hiveId'),
        }) as string
      }
      onSearch={onSearch}
      selectedValue={selectedValue}
      data-testid="hive-id-filter"
    />
  )
}
